export default () => ({
    display: 'flex',
    flexDirection: 'column-reverse',

    height: '100%',
});
